import { EXPLORER_PALETTE } from './fractalPalette';

// Vertical span is measured in complex-plane units. Derive horizontal span
// from the canvas proportions so both axes have the same units per pixel.
export function viewportFromCenter([x, y], verticalSpan, width, height) {
  const horizontalSpan = verticalSpan * width / height;
  return {
    xRange: [x - horizontalSpan / 2, x + horizontalSpan / 2],
    yRange: [y - verticalSpan / 2, y + verticalSpan / 2]
  };
}

function closeup(center, verticalSpan, height, gScale = 7, phaseOffset = 0) {
  const width = 1600;
  return {
    width,
    height,
    ...viewportFromCenter(center, verticalSpan, width, height),
    palette: { ...EXPLORER_PALETTE, gScale, phaseOffset }
  };
}

export const closeups = {
  // Fill the frame with a seahorse spiral instead of the mostly solid valley
  // overview. A slower color cycle separates its arms; the phase shift places
  // the open water in dark blue and the finer curls in teal and warm ivory.
  seahorse: closeup([-0.747, 0.108], 0.006, 1200, 5, 0.5),
  elephant: closeup([0.3, 0], 0.1, 1200),
  antenna: closeup([-1.97845, 0], 0.04, 800, 9),
  // Period-doubling limit: https://www.mrob.com/pub/muency/feigenbaumpoint.html
  feigenbaum: closeup([-1.4011551890920506, 0], 0.065, 1200, 5, 0.5),
  // Double-spiral Julia medallion, figure 2: https://www.mrob.com/pub/muency/embeddedjuliaset.html
  juliaMedallion: closeup([-1.768620774, 0.002428273], 0.000009, 1200, 5, 0.5),
  // Elephant's Trunk: https://mandelbrot.neocities.org/gallery
  elephantTrunk: closeup([0.2777323864244548, 0.0073446267400780795], 0.000022258585623343838, 1200, 5, 0.5),
  // A double spiral on the period-2 side of Seahorse Valley.
  doubleSpiral: closeup([-0.7756838, 0.1364674], 0.0018, 1200, 5, 0.5),
  // Triple Spiral Valley: https://mandelbrot.neocities.org/gallery
  tripleSpiral: closeup([-0.087593732, 0.65509028], 0.0044, 1200),
  // Four-arm detail in https://www.mrob.com/pub/muency/r2c14.html
  quadSpiral: closeup([0.28245, 0.4831], 0.004, 1200, 5, 0.5),
  // Period-3 island: https://www.mrob.com/pub/muency/r2tseries.html
  miniMandelbrot: closeup([-1.759672, 0], 0.065, 1200, 5, 0.5),
  // Scepter detail (Seahorse's Horn): https://mandelbrot.neocities.org/gallery
  scepter: closeup([-1.25066, 0.02012], 0.0009, 1200),
  // Snowflake detail: https://mandelbrot.dev/
  snowflake: closeup([-0.658448, -0.466852], 0.00065, 1200, 5, 0.5)
};
